// extracted by mini-css-extract-plugin
export default {"wrapper":"Document_wrapper__ofRKd","main":"Document_main__tDyNi","docViewer":"Document_docViewer__IxOQg"};